//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import d2DemoArticle from './components/d2-demo-article';
export default {
  components: {
    'd2-demo-article': d2DemoArticle
  },
  data: function data() {
    return {
      containerType: 'full',
      scrollDelay: 10,
      scrollTop: 0
    };
  },
  computed: {
    // 是否开启 better scroll
    betterScroll: function betterScroll() {
      return this.$route.query.bs === 'true';
    },
    // 根据滚动位置返回文章的样式
    articleStyle: function articleStyle() {
      return {
        opacity: this.scrollTop > 55 ? '1' : '.1'
      };
    }
  }
};